module.exports = __webpack_public_path__ + "img/hero-background-fireworks2.c256d4b8.jpeg";